export default __webpack_public_path__ + "static/media/DSC02574.b94af0be.jpg";